<div class="accession">
  <div class="accession-wrap">
    <div class="accession-content">
      <div class="accession-header">
        <h1 [innerHTML]="'HOME.TITLE' | translate" class="accession-title"></h1>
        <div class="accession-header-inner">
          <h3 [innerHTML]="'HOME.RATE' | translate" class="accession-rate"></h3>
          <img
            alt="girl-mobile"
            class="accession-header__img"
            height="180"
            ngSrc="/assets/images/landing/home/girl-mobile.webp"
            priority
            width="234"
          />
          <h3 class="accession-subtitle">
            {{ 'HOME.SUBTITLE' | translate }}
          </h3>
          <app-button
            (click)="navigateLogin()"
            [label]="'CALCULATE.BTN' | translate"
            color="secondary-gradient"
            size="landing"
          ></app-button>
        </div>
      </div>
    </div>
  </div>
</div>
